// extracted by mini-css-extract-plugin
export var black = "_38-6";
export var brand = "_38-1";
export var ddefault = "_38-0";
export var error = "_38-3";
export var gray = "_38-2";
export var highContrast = "_38-8";
export var outline = "_38-7";
export var success = "_38-5";
export var warning = "_38-4";